import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { MapBounds, MapCenter } from 'src/app/shared/interface/map.interface';
import { MapConfig } from 'src/app/_shared/config/map.config';
import { FavoriteService } from 'src/app/_shared/service/favorite.service';
import { DealAnalysisState } from 'src/app/_shared/state/deal-analysis.state';
import { FavoriteState } from 'src/app/_shared/state/favorite.state';
import { UserState } from 'src/app/_shared/state/user.state';
import { WorkspaceState } from '../../../_shared/state/workspace.state';
import { MapService } from '../../service/map.service';
import { MapState } from '../../state/map.state';
import { MarkerState } from '../../state/marker.state';
import { PropertyState } from '../../state/property.state';
import { SearchState } from '../../state/search.state';

@Injectable({
  providedIn: 'root',
})
export class MapFacade {
  errorMessage = {
    common: 'Some Error occurred,Please try later',
  };
  constructor(
    private userState: UserState,
    private dealAnalysisState: DealAnalysisState,
    private favoriteService: FavoriteService,
    private favoriteState: FavoriteState,
    private mapConfig: MapConfig,
    private mapState: MapState,
    private markerState: MarkerState,
    private propertyState: PropertyState,
    private searchState: SearchState,
    private snackBar: MatSnackBar,
    private workspaceState: WorkspaceState,
    public mapService: MapService
  ) {
    this.initSubscription();
  }

  initSubscription() {
    this.searchState.searchAddress$.subscribe((res: any) => {
      this.workspaceState.initiateSubjectPropertyValue = true;
      if (res && res.center) {
        this.mapState.mapCenterValue = res.center;
      }
    });
  }

  getMapTheme() {
    return this.mapConfig.mapTheme;
  }

  getInitialMapCenter(): { lat: number; lng: number } {
    const searchAddress: any = this.searchState.searchAddressValue;
    if (searchAddress && searchAddress.center) {
      return searchAddress.center;
    }
    const userAddress = this.userState.userDetails?.workPlace || {};
    if (userAddress.userLocation) {
      return userAddress.userLocation;
    }
    return this.mapConfig.defaultCenter;
  }

  getMapCenterChange(): Observable<any> {
    return new Observable((observer) => {
      this.searchState.searchAddress$.subscribe((res: any) => {
        if (res) {
          observer.next(res && res.center);
        }
      });
    });
  }

  getDefaultZoom() {
    return this.mapConfig.defaultZoom;
  }

  getMapZoom() {
    return this.mapState.mapZoomValue;
  }

  getMapZoom$(): Observable<number> {
    return this.mapState.mapZoom$;
  }

  initMarkerRender$(): Observable<boolean> {
    return this.propertyState.initiateRender$;
  }

  isClustered$() {
    return new Observable((observer) => {
      this.mapState.mapZoom$.subscribe((res) => {
        if (res >= this.mapConfig.defaultZoom) {
          observer.next(false);
        } else {
          observer.next(true);
        }
      });
    });
  }

  setBoundingBox(bounds: MapBounds) {
    this.mapService.setBoundingBox(bounds);
  }

  getCenter$(): Observable<any> {
    return this.mapState.mapCenter$;
  }

  setCenter(center: MapCenter) {
    const mapCenter = this.mapState.mapCenterValue;
    if (mapCenter.lat != center.lat || mapCenter.lng != center.lng) {
      this.mapService.setCenter(center);
    }
  }

  isClusteredViewActive$(): Observable<boolean> {
    return this.mapState.isClusteredView$;
  }

  isClusteredViewActive() {
    return this.mapState.isClusteredViewValue;
  }

  isLoading(): Observable<boolean> {
    return this.workspaceState.isSearchProcessing$;
  }

  getInfoWindowContent(PMXPropertyId): string {
    return this.mapService.getInfoWindowContent(PMXPropertyId);
  }

  hideListingInfo(PMXPropertyId) {
    this.mapService.hideListingInfo(PMXPropertyId);
  }

  get defaultFollowGroup() {
    const followGroups = this.favoriteState.followGroupListValue;
    if (followGroups) {
      const defaultGroup = followGroups.find((el) => el.mode === 'Default');
      return defaultGroup && defaultGroup.id ? [defaultGroup.id] : null;
    } else {
      return null;
    }
  }

  addFavorite(input) {
    const inputParams = {
      PMXPropertyIdList: [input.PMXPropertyId],
      GroupIds: this.defaultFollowGroup,
      stateList: [input.state],
    };
    this.favoriteService.addFavorites(inputParams).subscribe((response: any) => {
      // if (response && response.error) {
      //   const message = response.error.Message ? response.error.Message : this.errorMessage.common;
      //   this.openSnackBar(message, 'snackbar-error');
      // }
    });
  }

  removeFavorite(inputParams) {
    this.favoriteService.unFollowFavorite(inputParams).subscribe((response: any) => {
      // if (response && response.status && response.status === 'success') {
      //   // this.openSnackBar(response.Message, 'snackbar-success');
      // } else {
      //   const message = response.Message ? response.Message : this.errorMessage.common;
      //   this.openSnackBar(message, 'snackbar-error');
      // }
    });
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  getShowMapControls(): Observable<any> {
    return this.mapState.showMapControls$;
  }

  setShowMapControls(status) {
    this.mapState.showMapControlsValue = status;
  }

  // switchZoomRestrictionDialog() {
  //   let dialogClosed$: Subscription;
  //   this.mapState.searchLimitExceeded.subscribe((res) => {
  //     if (res) {
  //       const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //         width: '400px',
  //         disableClose: true,
  //         hasBackdrop: true,
  //         data: {
  //           type: 'mapZoomControl',
  //           message: "We couldn't continue with this zoom limit.",
  //           title: '',
  //         },
  //       });
  //       dialogClosed$ = dialogRef
  //         .afterClosed()
  //         .pipe(take(1))
  //         .subscribe((result) => {
  //           if (result) {
  //             this.mapState.mapZoomValue = this.mapState.mapZoomValue + 1;
  //           } else {
  //             return false;
  //           }
  //         });
  //     }
  //   });
  // }

  clearGoogleMarkerList() {
    this.markerState.googleMarkerListValue = [];
  }

  getSearchSuccessMessage$(): Observable<any> {
    return this.mapState.searchSuccessMessage$;
  }

  openDealAnalysisSheet() {
    this.dealAnalysisState.openDealAnalysisSheetValue = true;
  }

  getActivePropertyDetails(): Observable<any> {
    return this.propertyState.activePropertyDetails$;
  }

  getActiveListingData(): Observable<any> {
    return this.propertyState.listingInformation$;
  }

  setDefaultDealAnalysisValues(property) {
    let defaultInput: object = {};
    this.propertyState.activePropertyDetailsValue = property;
    // this.propertyState.activePropertyValue = {
    //   PropertyId: property.PropertyId,
    //   StateOrProvince: property.StateOrProvince,
    //   PropensityToSell: property.PropensityToSell,
    //   PMXPropertyId: property.PMXPropertyId,
    //   isFavorite: property.isFavorite,
    //   isFiltered: property.isFiltered,
    //   Lst_ListPrice: property.Lst_ListPrice,
    //   Lst_ListingId: property.Lst_ListingId,
    //   Lst_OriginalListPrice: property.Lst_OriginalListPrice,
    //   Lst_ClosePrice: property.Lst_ClosePrice,
    //   Lst_ListingContractDate: property.Lst_ListingContractDate,
    //   Lst_StandardStatus: property.Lst_StandardStatus,
    //   Lst_ListAgentFullName: property.Lst_ListAgentFullName,
    //   Lst_ListAgentPhone: property.Lst_ListAgentPhone,
    //   Lst_ListAgentEmail: property.Lst_ListAgentEmail,
    //   Lst_ListAgentOfficeName: property.Lst_ListAgentOfficeName,
    //   Lst_FlipDuration: property.Lst_FlipDuration,
    //   CapRate: property.CapRate ? property.CapRate : null,
    //   RentValue: property.RentValue ? property.RentValue : null,
    //   CurrentAVMValue: property.CurrentAVMValue ? property.CurrentAVMValue : null,
    // };
    if (this.mapState.mapZoomValue >= this.mapConfig.defaultZoom) {
      this.propertyState.activePropertyValue = property;
    }
    defaultInput['uPurchasePrice'] =
      property &&
      property.Lst_StandardStatus &&
      ['Active', 'Active Under Contract', 'Pending'].indexOf(property.Lst_StandardStatus) >= 0
        ? parseInt(property.Lst_ListPrice, 10)
        : property.CurrentAVMValue
        ? typeof property.CurrentAVMValue == 'string' && property.CurrentAVMValue.indexOf('$') > -1
          ? parseInt(property.CurrentAVMValue.replace(/[$,]/g, ''), 10)
          : parseInt(property.CurrentAVMValue, 10)
        : null;
    defaultInput['uLandValue'] =
      property && property.AssessedLandValue ? parseInt(property.AssessedLandValue, 10) : null;
    defaultInput['uPropertyTaxAmount'] =
      property && property.TaxAnnualAmount
        ? typeof property.TaxAnnualAmount == 'string' && property.TaxAnnualAmount.indexOf('$') > -1
          ? parseFloat(property.TaxAnnualAmount.replace(/[$,]/g, ''))
          : parseFloat(property.TaxAnnualAmount)
        : null;
    defaultInput['uMonthlyRent'] = property && property.RentValue ? property.RentValue : null;
    defaultInput['uAssessedPropertyValue'] =
      property && property.AssessedValue ? parseInt(property.AssessedValue) : null;
    defaultInput['uFairMarketValue'] =
      property && property.CurrentAVMValue
        ? typeof property.CurrentAVMValue == 'string' && property.CurrentAVMValue.indexOf('$') > -1
          ? parseInt(property.CurrentAVMValue.replace(/[$,]/g, ''), 10)
          : parseInt(property.CurrentAVMValue, 10)
        : null;
    defaultInput['uState'] = property && property.StateOrProvince ? property.StateOrProvince : null;
    defaultInput['listingId'] = property && property.Lst_ListingId ? property.Lst_ListingId : null;
    this.dealAnalysisState.defaultDealAnalysisInputValue = defaultInput;
    this.openDealAnalysisSheet();
  }
}
